import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';
import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import NewsesList from '../../../components/settings/news/general/list';
import PermissionsService from '../../../services/permissions';
import NoAccess from '../../../components/uiframeworks/noAccess';

interface IPublicNewsPageProps {
}

const PublicNewsPage: React.FC<IPublicNewsPageProps> = (props: IPublicNewsPageProps) => {
  const { topbar, user } = useStore();

  useEffect(() => {
    topbar.show("News", [
      { key: "home", icon: faHome, href: "/" },
      { key: "settings", text: 'Settings', href: "/settings" },
      { key: "news", text: 'Public News' }
    ])
  }, []);

  const hasPermission = PermissionsService.hasPermission(['news.read.all'], user.permissions);

  return (
    <Stack>
      {hasPermission ? <NewsesList /> : <NoAccess />}
    </Stack>
  );
};

export default PublicNewsPage;
